type StringReplacements = {
  [key: string]: any;
};

export const createJsonTranslator = <TEXT_KEY extends string>(json: Record<TEXT_KEY, string>) => {
  return (key: TEXT_KEY, stringReplacements: StringReplacements = {}): string => {
    let text = json[key] || key;
    Object.entries(stringReplacements).forEach(([replacementKey, replacementValue]) => {
      text = text.split(`\${${replacementKey}}`).join(replacementValue);
    });
    return text;
  };
};
